import {Group, Text} from '@mantine/core';
import {Dropzone} from '@mantine/dropzone';
import React from 'react';
import {IoCloseCircle, IoImageOutline} from 'react-icons/io5';
import {BaseInputProps} from '../..';

import {Container, Title, Index, Row, DropdownContainer} from './styles';
import {SelectedFile} from './components';
import {useController, useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';

export interface FileSelectProps<T = any> extends BaseInputProps {
  name: NestedKeys<T>;
  index?: number;
  multi?: boolean;
}

const FileSelect: React.FC<FileSelectProps> = ({name, label, index, multi}) => {
  const {control} = useFormContext();
  const {field} = useController({control, name});

  const files = multi ? ((field.value ?? []) as File[]) : undefined;
  const file = multi ? undefined : (field.value as File);

  return (
    <Container>
      <Row>
        {index && <Index>{index}</Index>}
        <Title>{label}</Title>
      </Row>
      {(!file || multi) && (
        <Dropzone
          onDrop={(data) => {
            field.onChange(multi ? [...files!, ...data] : data[0]);
          }}
          onReject={(files) => console.log('rejected files', files)}
          maxSize={3 * 1024 ** 2}>
          <Group
            align="center"
            gap="xl"
            style={{
              pointerEvents: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Dropzone.Accept>
              <IoImageOutline />
            </Dropzone.Accept>
            <Dropzone.Reject>
              <IoCloseCircle />
            </Dropzone.Reject>
            <Dropzone.Idle>
              <IoImageOutline size={40} color="rgba(0, 0, 0, .7)" />
            </Dropzone.Idle>
            <DropdownContainer>
              <Text size="xl" inline>
                Arraste e solte ou clique para selecionar arquivos
              </Text>
              <Text size="sm" color="dimmed" inline mt={7}>
                Adicione quantos arquivos quiser, o limite é de 3MB por arquivo
              </Text>
            </DropdownContainer>
          </Group>
        </Dropzone>
      )}
      {files && files?.length > 0 && multi && (
        <Title>Arquivos selecionados</Title>
      )}
      {files?.map((file, index) => (
        <SelectedFile
          key={index}
          {...{
            file,
            remove: () => field.onChange(files.filter((_, i) => i !== index)),
          }}
        />
      ))}
      {file && (
        <SelectedFile
          {...{
            file,
            remove: () => field.onChange(null),
          }}
        />
      )}
    </Container>
  );
};

export default FileSelect;
